import React, {useEffect, useState} from 'react'
import { v4 as uuidv4 } from 'uuid';
import { addValueForDropdown, listOptions, fieldVisibleByDevice, initialValue, sortLabelCompare, translatedLabel } from '../lib/utils'; 
import {FieldDropdown, NewDeviceField, TextField} from '.';
import {useStateContext} from '../context/StateContext';
import {BsToggleOn, BsToggle2Off} from 'react-icons/bs';
import { expandReference, keyId } from '../lib/utils';
import {VisDiv} from '.';
import { TiDelete } from 'react-icons/ti';
import Wheel from './Wheel';
import useMediaQuery from '../hooks/useMediaQuery';
import { yearsList, monthsList } from '../lib/utils';
import TestButton from './frontend_components/TestButton';



/**
 * 
 * @param {*} item is an object of dataModule type
 * @param {*} currentTemplateDevice is the register template of the device to which the field is added
 * @param {*} deviceFields is the array where I save the field
 * @param {*} setDeviceFields hook to add or edit to the array where the fieled is saved
 * @returns a dropdown with options, text input field or boolean button
 * 
 * This function takes a template field, adds a value to it and then saves it to an array of fields
 */

const RegisterTemplateData = ({fieldMessages, setTrackedChanges=()=>{}, errorCallback=()=>{}, trackedChanges=[], item, currentTemplateDevice, deviceFields, setDeviceFields, isError, errorMessage, registerTemplate, device}) => 
{
    const screenSizeDesktop = useMediaQuery("(min-width: 1600px)")
  
    const key = item?._id

    const [value, setValue] = useState({})
    //const [initialValue, setInitialValue] = useState(undefined)
    const [singleValue, setSingleValue] = useState()
    const [innerError, setInnerError] = useState()
    const {currentDevice, setCurrentDevice, deviceEdit, setDeviceEdit, LDB } = useStateContext();
    const availableDevice = device ? device : currentDevice
    const testing = false
    const P = "fields"

    const options = addValueForDropdown(listOptions(item, currentTemplateDevice))
    useEffect(() => {
        if(innerError && singleValue?.label && options?.some((x) => x?.label == singleValue?.label)){
                errorCallback(undefined)
                setInnerError(undefined)
                }
        if(!innerError && singleValue?.label && !options?.some((x) => x?.label == singleValue?.label)) 
            {
                const error = {check: true, isError: true, errorMessage:"CAMPO SELEZIONATO NON IN LISTA"}
                errorCallback(error)
                setInnerError(error)
                console.log("alskmlamdl options changing and no option in list",{options, singleValue})
             }
    },[options])

    const isErrorFn = () => {
        if(isError && errorMessage){
            return {errorMessage, isError}
        }
        if(innerError){
            //console.log("innerError wlkdjqwlkd",innerError)
            return innerError
        }
    }

    function compare( a, b ) {
        if ( a?.label < b?.label ){
          return -1;
        }
        if ( a?.label > b?.label ){
          return 1;
        }
        return 0;
      }
    
    useEffect(() => { 
        if(availableDevice) {
            setSingleValue(initialValue(availableDevice, item, deviceFields))
        }
        //console.log("jnjdkandaksjdnasjkd useEffectSingleValue",{singleValue, currentTemplateDevice, deviceFields, availableDevice, initialValue: initialValue(availableDevice, item, deviceFields)})
        }, [deviceFields] )
    
    const referenceTemplateField = {
        _type: 'reference',
        _ref: item?._id
        }


    if(item?._type !=="dataModule" || !currentTemplateDevice){
        // Return null instead of undefined for invalid cases
        return null;
    }

    const onChangeConsoles = () => {
        console.log("current device template",currentTemplateDevice)
        console.log("value passed:",value)
        console.log("item:",item)
    }


    const updateDeviceFields = (value, remove=false) =>{

        const existingTemplateIndex = deviceFields?.findIndex((x)=>x?.templateField?._ref == referenceTemplateField?._ref )
        const existingField = !Array.isArray(deviceFields) ? undefined : deviceFields?.find?.((x)=>x?.templateField?._ref == referenceTemplateField?._ref )
        
        const values = (value) => {
            let values = []
            if(value?.length>-1){
                return value
            } else {
                values.push(value)
                return values
            }
        }


        const trackData = {registerTemplate, device, referenceTemplateField, updatedValue: value, trackedChanges, remove: remove}    
        if (existingField) {
            if( !values(value)[0] || 
                values(value).length==0 ||
                !values(value)[0].value || remove )
                {  

                trackDoc(trackData, setTrackedChanges)

                //console.log("deleting",existingTemplateIndex, trackDoc(trackData, setTrackedChanges)?.string)

                const newArray = !Array.isArray(deviceFields) ? [] : deviceFields?.filter((x=>x?.templateField?._ref !== referenceTemplateField?._ref))
                //newArray.splice(existingTemplateIndex,1)
                setDeviceFields(newArray)
            } else {
                
                trackDoc(trackData, setTrackedChanges)
                //console.log("EXISTS Index, I UPDATE", existingTemplateIndex, trackDoc(trackData, setTrackedChanges)?.string)

                //let newArray = [...deviceFields]
                //newArray.splice(existingTemplateIndex,1)

                setDeviceFields([...!Array.isArray(deviceFields) ? [] : deviceFields?.filter((x=>x?.templateField?._ref !== referenceTemplateField?._ref)),{             
                    templateField: referenceTemplateField,
                    values: values(value),       
                    _key: keyId(),
                }]) 

            }
        } else {
            trackDoc(trackData, setTrackedChanges)
            //console.log("DOES NOT EXIST, I CREATE IT", trackDoc(trackData, setTrackedChanges)?.string)
            
            setDeviceFields([...!Array.isArray(deviceFields) ? [] : deviceFields,{             
                templateField: referenceTemplateField,
                values: values(value),
                _key: keyId(), 
            }])
        }
/*         if(existingTemplateIndex > -1){

            changes: jqowsjqwoijswqilsjwqoijswqoilsj
            
            if( !values(value)[0] || 
                values(value).length==0 ||
                !values(value)[0].value || remove )
                {  

                trackDoc(trackData, setTrackedChanges)

                //console.log("deleting",existingTemplateIndex, trackDoc(trackData, setTrackedChanges)?.string)

                let newArray = [...deviceFields]
                newArray.splice(existingTemplateIndex,1)
                setDeviceFields([...newArray])
            } else {
                
                trackDoc(trackData, setTrackedChanges)
                //console.log("EXISTS Index, I UPDATE", existingTemplateIndex, trackDoc(trackData, setTrackedChanges)?.string)

                let newArray = [...deviceFields]
                newArray.splice(existingTemplateIndex,1)

                setDeviceFields([...newArray,{             
                    templateField: referenceTemplateField,
                    values: values(value),       
                    _key: keyId(),
                }]) 

            }
            
        } else {
            trackDoc(trackData, setTrackedChanges)
            //console.log("DOES NOT EXIST, I CREATE IT", trackDoc(trackData, setTrackedChanges)?.string)
            
            setDeviceFields([...deviceFields,{             
                templateField: referenceTemplateField,
                values: values(value),
                _key: keyId(), 
            }])
        } */
    }

    const removeDeviceField = (value) => {
        
        updateDeviceFields(value, true)
/*         setDeviceFields([
            ...deviceFields
             ?.filter?.((x)=>{
                return !x?.values?.some?.((y)=>y?._id == value?._id)
                })
            ]) */
    }
    
    switch (item.fieldType) {
        case "boolean": {
            //console.log("bool", initialValue(availableDevice, item, deviceFields), "single value",singleValue) 

            const newKey = uuidv4()
            const newField = {
                _type: "deviceProperty",
                value: item.value,
                label: item.value,
                _key: keyId()

            }
           
            const icon = singleValue
                ? <BsToggleOn className="toggle-icon-true" />
                : <BsToggle2Off className="toggle-icon-false"/>

            const onClick = () =>{
                if(!initialValue(availableDevice, item, deviceFields)){
                    if(!singleValue){
                        setSingleValue(true)
                        updateDeviceFields(newField)
                        //console.log("1:", singleValue)  
                    } else {
                        setSingleValue(!singleValue)
                        updateDeviceFields({})
                        //console.log("2:", singleValue)
                    }
                    
                } else {
                    setSingleValue(!initialValue(availableDevice, item, deviceFields))
                    //setInitialValue(undefined)
                    updateDeviceFields({value:undefined})
                    //console.log("3:",singleValue)
                }

            }
            return (
                <>
                    <NewDeviceField key={key} label={translatedLabel(item, LDB)}>
                        <button 
                            type="button"

                            onClick={()=>{
                                onClick()
                            }}
                            className="toggle-button"
                        >
                            {icon}
                        </button>
                    </NewDeviceField>
                </>
            )
        }
        case "dropdown": {
            
            
            const isVisible = () => fieldVisibleByDevice(item, currentTemplateDevice, deviceFields)
            //console.log("IN DROPDOWN", item)
            if(item?.dateType && isVisible()) {

                const testFunction = () => {
                    console.log("SINGLE VALUE", singleValue)
                }

                const initialValue = () => {
                    const date = singleValue?.dateObject
                    const month = date?.month ? date?.month :"mese?"
                    const year = date?.year ? date?.year :"anno?"
                    if(!singleValue) return ""
                    if(date) return `${month}/${year}`
                    return singleValue?.label
                }
                const dropdownInitialValue = () => {
                    const date = singleValue?.dateObject
                    if(!singleValue) return {}
                    if(date) return ({year: {label: date?.year?.toString(), value: date?.year?.toString()}, month: {label: date?.month?.toString(), value: date?.month?.toString()}})
                    return {year: {label: singleValue?.label, value: singleValue?.label}, month: {label: "1", value: "1"}}
                }
                const deleteDate = () => {
                    //console.log("DELETE whedhed", singleValue, deviceFields)

                    removeDeviceField(singleValue)
                    //setValue(undefined)
                    //setSingleValue(undefined)
                }
                const dateValue = (data) => ({
                    _id: uuidv4(),
                    _key: keyId(),
                    _type: "deviceProperty",
                    //label: `${data?.month}/${data?.year}`,
                    //value: `${data?.month}/${data?.year}`,
                    label: data?.year?.toString(),
                    value: data?.year?.toString(),
                    dateObject: {year: data?.year, month: data?.month}
                })

                const save = (data) => {
                    console.log("SAVE DATE", data)
                    setValue(dateValue(data))
                    updateDeviceFields(dateValue(data))
                    setSingleValue(dateValue(data))
                }
                const wheelInitialValue = () => {
                    const dateValue = Number(singleValue?.value)
                    //console.log("SINGLE VALUE", singleValue)
                    if(singleValue?.dateObject) return singleValue?.dateObject
                    if(dateValue > 1900 && dateValue < 2030 && !singleValue?.dateObject){
                        const dateObj = {
                            month: 1,
                            year:dateValue
                        }
                        //console.log("SINGLE VALUE DATE", dateObj)
                        return dateObj }
                }
                

                return (
                    <NewDeviceField  key={key} label={translatedLabel(item, LDB)}>
                        <VisDiv rules={[!screenSizeDesktop]} style={{display:"flex", alignItems:"center", marginTop:"5px"}}>         
                            <Wheel saveFn = {save} initialData = {wheelInitialValue()}/>
                            <div style={{marginLeft:"10px"}}>
                                {initialValue()}  
                            </div>
                            <VisDiv rules = {[initialValue()]} style={{marginLeft:"30px"}}>
                                <button
                                    type="button"
                                    className="remove-item"
                                    onClick={() => deleteDate()}
                                    >
                                    <TiDelete />
                                </button>
                            </VisDiv>
                         
                        </VisDiv>
                        <VisDiv style={{display:"flex", alignItems:"center"}} rules={[screenSizeDesktop]}>
                            {/* <button onClick={testFunction}>TEST</button> */}
                            <VisDiv rules={[singleValue?.dateObject?.year]} style={{minWidth:"100px"}}>
                                <FieldDropdown
                                    //hideDeselect={true}
                                    isError={isError}
                                    sorted={item?.sorted}
                                    errorMessage={errorMessage}
                                    isSearchable="isSearchable"
                                    initialValue={singleValue && dropdownInitialValue()?.month}
                                    placeHolder={"MESE"}
                                    options={monthsList()}
                                    onChange={(dropdownValue) => { 
                                        if(!dropdownValue?.value) {

                                            //console.log("singleValue kqjendkjen", {singleValue, value, dropdownValue})
                                            updateDeviceFields(dateValue({month: undefined, year: singleValue?.dateObject?.year }, true))
                                            setValue(dateValue({month: undefined, year: singleValue?.dateObject?.year }))
                                            setSingleValue(dateValue({month: undefined, year: singleValue?.dateObject?.year }))
                                            return
                                        }
                                        console.log("singleValue ofk34prkf4p3of", {singleValue, value, dropdownValue})
                                        setValue(dateValue({month: Number(dropdownValue?.value), year: singleValue?.dateObject?.year }))
                                        updateDeviceFields(dateValue({month: Number(dropdownValue?.value), year: singleValue?.dateObject?.year }))
                                        setSingleValue(dateValue({month: Number(dropdownValue?.value), year: singleValue?.dateObject?.year }))
                                    }}
                                />
                            </VisDiv>
                            <VisDiv rules={[singleValue?.dateObject?.year]} style={{marginLeft: "5px", marginRight:"5px"}}>{` / `}</VisDiv>
                            <VisDiv  style={{minWidth:"100px"}}>
                                <FieldDropdown
                                    isError={isError}
                                    //hideDeselect={true}
                                    //sorted={item?.sorted}
                                    errorMessage={errorMessage}
                                    //isMulti={item.isMulti ? true : false}
                                    isSearchable="isSearchable"
                                    descending={false}
                                    initialValue={singleValue ?? dropdownInitialValue()?.year}
                                    placeHolder={"ANNO"}
                                    options={yearsList(15)}
                                    onChange={(dropdownValue) => { 
                                        if(!dropdownValue?.value) {
                                            deleteDate()
                                            setSingleValue(undefined)
                                            //updateDeviceFields(dateValue({month: undefined, year: undefined }, true))
                                            //setValue(dateValue({month: undefined, year: undefined }))
                                            //setSingleValue(dateValue({month: undefined, year: undefined }))
                                            return
                                        }
                                        save({month: singleValue?.dateObject?.month ? singleValue?.dateObject?.month : 1 , year: Number(dropdownValue?.value)})
                                        //setValue(dateValue({month: singleValue?.dateObject?.month, year: Number(dropdownValue?.value)}))
                                        //updateDeviceFields(dateValue({month: singleValue?.dateObject?.month, year: Number(dropdownValue?.value)}))
                                    }}
                                />
                            </VisDiv>
                        </VisDiv>
                        
                    </NewDeviceField>
                )}

            const dropdownInitialValue = () => {
                if(!singleValue) return {}
                const date = singleValue?.dateObject
                if(date) return ({year: {label: date?.year?.toString(), value: date?.year?.toString()}, month: {label: date?.month?.toString(), value: date?.month?.toString()}})
                return {year: {label: singleValue?.label, value: singleValue?.label}, month: {label: "1", value: "1"}}
            }

            return (
            
                isVisible() && options?.length > 0  && 
                    <NewDeviceField key={key} label={translatedLabel(item, LDB)}>
                        <TestButton buttonId='dqòldkòqlwdlòk' message='register template data' consoleData={{item,currentTemplateDevice, options: listOptions(item, currentTemplateDevice), singleValue}}/> 
                        <FieldDropdown
                            isError={isErrorFn()?.isError}
                            sorted={item?.sorted}
                            errorMessage={isErrorFn()?.errorMessage}
                            isMulti={item.isMulti ? true : false}
                            isSearchable="isSearchable"
                            descending={item?.sortDescending}
                            initialValue={singleValue}//singleValue || dropdownInitialValue()
                            //placeHolder={match ? match : undefined}
                            options={options}
                            onChange={(value) => { 
                                //onChangeConsoles()
                                //item.isMulti && console.log("multi:",value)
                                console.log("value kqskjqwns:",{value, singleValue})
                                //setInitialValue(undefined)
                                setValue(value)
                                updateDeviceFields(value)
                                //console.log("device fields:",deviceFields)
                            }}
                        />
                    </NewDeviceField>
            )
        }
        default: 
            //console.log("default")
            const newKey = uuidv4()

            const fieldMessage = !Array.isArray(fieldMessages) ? undefined : fieldMessages?.find?.((x)=>x?.label == item?.label)
            return  (
             
            <NewDeviceField key={key} label={translatedLabel(item, LDB)}>  
                <VisDiv rules={[]}>
                    <p style={{color:"green"}}>{fieldMessage && fieldMessage?.message}</p>
                </VisDiv>  
                <TestButton buttonId='dashdauishdiu' message='register template data' consoleData={{item,currentTemplateDevice, fieldMessage, options: listOptions(item, currentTemplateDevice), singleValue}}/>  
          
                <TextField
                //value={singleValue} 
               
               // initialValue={match ? match : undefined}   
                //placeholder={initialValue()} 
                defaultValue= {singleValue} 
                onChange={(e) => setSingleValue(e.target.value)}
                isError={isError}
                errorMessage={errorMessage}
                onBlur={(data)=>{
                    //setValue(newField)
                    const newField = {
                        _type: "deviceProperty",
                        value: data?.target?.value,
                        label: data?.target?.value,
                        _key: keyId()
        
                    }
                    console.log("on blur:",  newField )
                    //console.log("on blur data:",  data?.target?.value)
                    //onChangeConsoles()
                    updateDeviceFields(newField)
                    //console.log("device fields:",deviceFields)
                    }} 
                />
                
                <VisDiv rules={[testing]}>
                    <button  onClick={()=>{
                        console.log("options", listOptions(item, currentTemplateDevice))
                        console.log("current template device", currentTemplateDevice)
                        console.log("item", item)
                        console.log("fieldMessage", fieldMessage)
                        
                        }}>test
                    </button>
                </VisDiv>
            </NewDeviceField>) 
            
    }
}

export default RegisterTemplateData

//    onblur={updateDeviceFields()}


/**
 * 
 * @param {*} data  {registerTemplate, device, referenceTemplateField, values, trackedChanges} 
 * @param {*} setTrackedChanges 
 * @returns 
 */

export const formatString = (value) =>{
    if(value?.dateObject) {
        const month = value?.dateObject?.month
        const year = value?.dateObject?.year
        if(!month && year) return year?.toString()
        if(!year && month) return month?.toString()
        return `${month}/${year}`    
    }
    if(!value?.label) return "assente"
    return value?.label
}

export const trackDoc = (data={}, setTrackedChanges=()=>{}) => {

    const values = (value) => {
        let values = []
        if(value?.length>-1){
            return value
        } else {
            values.push(value)
            return values
        }
    }

    const {registerTemplate, device, referenceTemplateField, trackedChanges, updatedValue, remove, oldDoc, fieldName} = data

    // field type
    const isPresidio = updatedValue?._type == "presidioModule"
    const isDeviceProperty = updatedValue?._type == "deviceProperty" || updatedValue?.[0]?._type == "deviceProperty" 

    if(oldDoc && fieldName) console.log("hsdbjhbc", oldDoc, fieldName, updatedValue)
    const templateFields = {
        fields: registerTemplate?.fields ? registerTemplate?.fields : [], 
        locations: registerTemplate?.locations ? registerTemplate?.locations : [],  
        dates: registerTemplate?.dates ? registerTemplate?.dates : [], 
        devices: registerTemplate?.devices ? registerTemplate?.devices : [], 
    }  
    const deviceFields = {
        fields: device?.fields ? device?.fields : [], 
        locations: device?.location ? device?.location : [],  
        dates: device?.dates ? device?.dates : [],  
        device: device? device : {}, 
    }  

    const allTemplateFields = !registerTemplate ? [] : [...templateFields?.fields, ...templateFields?.locations, ...templateFields?.dates, ...templateFields?.devices]
    const allDeviceFields = !device ? [] : [...deviceFields?.fields, ...deviceFields?.locations, ...deviceFields?.dates,  deviceFields?.device]

    const findExistingField = !Array.isArray(allDeviceFields) ? undefined : allDeviceFields?.find?.((x)=>x?.templateField?._ref == referenceTemplateField?._ref)
    const existingFieldInDevice = findExistingField ? findExistingField : {}

    const existingDeviceTemplate = !Array.isArray(allTemplateFields) ? undefined : allTemplateFields?.find?.((x)=>x?._id == device?.templateDevice?._ref)

    const newDevicePropertyField = {...existingFieldInDevice, _key: keyId(), _type:"deviceProperty", values: values(updatedValue)}
 
    const findTemplateField = !Array.isArray(allTemplateFields) ? undefined : allTemplateFields?.find?.((x)=>x?._id == referenceTemplateField?._ref)

    const formatValue = (valueArray=[], bypassRemove) => {
    
        if(valueArray?.length <= 0 || !valueArray || ( remove && !bypassRemove)) return "assente"

        if (valueArray?.length == 1){
            return formatString(valueArray?.[0])
        } 
        if (valueArray?.length > 1){
            const printedValues = valueArray?.map?.((valueObj, index)=> index == 0 ? formatString(valueObj) : " " + formatString(valueObj))
            return printedValues?.toString()
        }
     
    }
    
    const oldValue = () => {
        if(fieldName && typeof oldDoc == "string") return oldDoc
        if(isPresidio) return formatValue(values({label:device?.label}), true)
        if(isDeviceProperty)  return formatValue(existingFieldInDevice?.values, true) 
        //if(!existingFieldInDevice) return "assente"
        //return formatValue(existingFieldInDevice?.values, true)  
        return "assente"
     }

    const newValue = () => {
        if(fieldName && typeof updatedValue == "string") return updatedValue
        if(isDeviceProperty)  return formatValue(values(updatedValue))
        if(isPresidio) return formatValue(values(updatedValue))
        //if(!existingFieldInDevice) return "assente"
        //return formatValue(values(updatedValue))
        return "assente"
    } 
  
    const string = () => {
        if(fieldName) return `${fieldName} era ${oldValue()}, è ${newValue()}` 
        if(isPresidio) return `Presidio era ${oldValue()}, è ${newValue()}`
        if(!findTemplateField?.label) return `Era ${oldValue()}, è ${newValue()}` 
        return `${findTemplateField?.label} era ${oldValue()}, è ${newValue()}` 
    }

    const doc = () => {

        const commonDoc = {
            trackString: string(),
            templateLabel: findTemplateField?.label,
            //updatedValue
        }    
        const propertyDoc = {
            ...commonDoc,
            oldValueId: existingFieldInDevice?._id,
            oldPropertyValue: existingFieldInDevice,
            newPropertyValue:  remove ? {} : newDevicePropertyField,
        }   
        const presidioDoc = {
            ...commonDoc,
            oldValueId: existingDeviceTemplate?._id,
            oldDeviceTemplate: {_key: keyId(), _type:"reference", _ref: existingDeviceTemplate?._id},
            newDeviceTemplate: remove ? {} : {_key: keyId(), _type:"reference", _ref: updatedValue?._id},
        
        } 
        const manualDoc = () => {
            if(isDeviceProperty) return ({
                ...commonDoc,
                templateLabel: fieldName,
                oldValueId: oldDoc?._id,
                oldPropertyValue: oldDoc,
                newPropertyValue:  remove ? {} :updatedValue,
            })
            if(isPresidio) return ({
                ...commonDoc,
                oldValueId: existingDeviceTemplate?._id,
                oldDeviceTemplate: {_key: keyId(), _type:"reference", _ref: existingDeviceTemplate?._id},
                newDeviceTemplate: remove ? {} :{_key: keyId(), _type:"reference", _ref: updatedValue?._id},
            
            })
            return ({...commonDoc, oldStringValue: oldDoc?.toString() , newStringValue: updatedValue?.toString(),})
        }  
        if(fieldName) return manualDoc()
        if(isPresidio) return presidioDoc
        if(isDeviceProperty) return propertyDoc
        return ({...commonDoc, oldStringValue: oldDoc?.toString() , newStringValue: remove ? "" :updatedValue?.toString(),})
    }
    console.log("tracking", doc())
    setTrackedChanges([...trackedChanges
        ?.filter?.((x)=>{
            if(!doc()?.oldValueId) return x?.templateLabel !==  doc()?.templateLabel
            return x?.oldValueId !== doc()?.oldValueId
 
        }     
            ), (oldValue() !== newValue()) && doc()]?.filter?.(x=>x)
    )
    return doc()
}
